import { updateWhenThemeChanges } from './theming-controller.js';
export function themes(themes, exposeTheme = false) {
    return (clazz) => {
        clazz.addInitializer((instance) => {
            updateWhenThemeChanges(instance, themes, exposeTheme);
        });
        return clazz;
    };
}
export { themeSymbol } from './theming-controller.js';
